import { isMapRoute } from "../hooks/useLastMapUrl";

// Returns the URL the logo (or any "go home"-style control) should point to.
// Pure function so it can be unit-tested without mounting the Navbar.
//
// Rules, in order:
//   1. On a map route → "/" (clears state).
//   2. Has prior map history → return where they came from.
//   3. Cold deeplink to an event-only vendor → that vendor's event page.
//   4. Fallback → "/".
export const getLogoUrl = ({ pathname, lastMapUrl, hasMapHistory, restaurants }) => {
  if (isMapRoute(pathname)) return "/";
  if (hasMapHistory) return lastMapUrl;

  const detailsMatch = pathname.match(/^\/details\/([^/]+)/);
  if (detailsMatch && restaurants?.length) {
    const restaurant = restaurants.find((r) => r._id === detailsMatch[1]);
    const eventSlug = restaurant?.event?.slug;
    if (restaurant?.eventOnly && eventSlug) {
      return `/events/${eventSlug}`;
    }
  }

  return "/";
};
